var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"add-origin-destination",attrs:{"cols":"12"}},[_c('button',{class:`add-origin-destination__button ${
      _vm.disabled ? 'add-origin-destination__button--disabled' : ''
    }`,attrs:{"type":"button","role":"button","disabled":_vm.disabled},on:{"click":() => _vm.$emit('add:origin-destination')}},[_c('span',[_vm._v("Aggiungi un altro volo")]),_c('vb-icon',{attrs:{"name":"plus_circle","size":16}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }